import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';

export class RemoveQueryHistoryAction implements HistoryAction {
  actions = {
    [HISTORY_ACTIONS_KEYS.removeQueryHistory]: ({ commit, state, getters }: HistoryContext, historyTerm: string): any => {
      commit(HISTORY_MUTATIONS_KEYS.removeQueryHistory, historyTerm);
      const storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      storageService.setItem(getters.storageKey, state.queryHistory);
    }
  };
}
